import { useState } from "react";
import { avatarColor, initials } from "../live/liveCircle";

/**
 * A member's photo, falling back to coloured initials (also while it loads or
 * if it fails). Pass `avatar_small_url` unless it is drawn larger than a list row.
 */
export function MemberAvatar(props: { userId: string; name: string; avatarUrl: string | null; isSelf: boolean }) {
  const [failed, setFailed] = useState<string | null>(null);
  const url = props.avatarUrl;
  const photo = url && failed !== url ? url : null;
  return (
    <span
      className={`member-avatar${props.isSelf ? " self" : ""}`}
      style={{ background: avatarColor(props.userId) }}
      aria-hidden="true"
    >
      {initials(props.name)}
      {photo && <img src={photo} alt="" decoding="async" onError={() => setFailed(photo)} />}
    </span>
  );
}
